import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { OrderedMap, Set, Map } from 'immutable';
import VisibilitySensor from 'react-visibility-sensor';
import get from 'lodash/get';

import { AddOns as AddOnsModel } from 'models/addons';
import { Location } from 'models/locations';

import OptionalAddOns from 'components/checkout/add-ons/optional';
import RequiredAddOns from 'components/checkout/add-ons/required';

import { ADDITIONS_IMPRESSION, PRICING_OPTION_CLICK } from 'lib/analytics/events';
import Search from 'models/search';

const propTypes = {
  setShouldScrollToError: PropTypes.func.isRequired,
  modifyRequiredFieldList: PropTypes.func.isRequired,
  requiredFields: PropTypes.instanceOf(Set).isRequired,
  requiredFieldErrors: PropTypes.oneOfType([
    PropTypes.instanceOf(OrderedMap),
    PropTypes.instanceOf(Map),
  ]).isRequired,
  shouldScrollToError: PropTypes.bool.isRequired,
  selectedAddOns: PropTypes.instanceOf(AddOnsModel),
  changeAddOns: PropTypes.func.isRequired,
  currentSearch: PropTypes.instanceOf(Search),
  addOns: PropTypes.instanceOf(AddOnsModel),
  trackEvent: PropTypes.func.isRequired,
  location: PropTypes.instanceOf(Location).isRequired,
};

const defaultProps = {
  selectedAddOns: new AddOnsModel(),
  currentSearch: new Search(),
  addOns: new AddOnsModel(),
};

export class AddOns extends Component {
  constructor(props) {
    super(props);

    this.handleSelectedAddOn = this.handleSelectedAddOn.bind(this);
    this.onAdditionsChangeVisibilityChange = this.onAdditionsChangeVisibilityChange.bind(this);
  }

  onAdditionsChangeVisibilityChange(isVisible) {
    const { currentSearch, addOns } = this.props;
    if (isVisible) {
      const vehicleSize = get(addOns, 'vehicleSize', []);
      this.props.trackEvent({
        ...ADDITIONS_IMPRESSION,
        properties: {
          LocationID: currentSearch.selectedLocationId,
          PricingName: vehicleSize.map(vehicle => vehicle.name).join(','),
          PricingCode: vehicleSize.map(vehicle => vehicle.id).join(','),
        },
      });
    }
  }

  handleSelectedAddOn(addOnType, addOn, action) {
    this.props.changeAddOns({ addOnType, addOn, action });
    this.props.trackEvent({
      ...PRICING_OPTION_CLICK,
      properties: {
        LocationID: this.props.currentSearch.selectedLocationId,
        PricingName: addOn.name,
        PricingCode: addOn.id,
      },
    });
  }

  render() {
    if (!this.props.addOns) { return null; }

    return (
      <VisibilitySensor onChange={this.onAdditionsChangeVisibilityChange} partialVisibility>
        <div>
          <RequiredAddOns
            addOns={this.props.addOns.getRequiredAddOns()}
            location={this.props.location}
            selectedAddOns={this.props.selectedAddOns}
            handleSelectedAddOn={this.handleSelectedAddOn}
            requiredFields={this.props.requiredFields}
            requiredFieldErrors={this.props.requiredFieldErrors}
            shouldScrollToError={this.props.shouldScrollToError}
            setShouldScrollToError={this.props.setShouldScrollToError}
            modifyRequiredFieldList={this.props.modifyRequiredFieldList}
          />
          <OptionalAddOns
            addOns={this.props.addOns.getOptionalAddOns()}
            location={this.props.location}
            selectedAddOns={this.props.selectedAddOns}
            handleSelectedAddOn={this.handleSelectedAddOn}
          />
        </div>
      </VisibilitySensor>
    );
  }
}

AddOns.propTypes = propTypes;
AddOns.defaultProps = defaultProps;
export default AddOns;
